import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "index",
    component: function () {
      return import("../views/IndexView.vue");
    },
  },
  {
    path: "/create",
    name: "create",
    component: function () {
      return import("../views/CreateAccount.vue");
    },
  },
  {
    path: "/import",
    name: "import",
    component: function () {
      return import("../views/ImportAccount.vue");
    },
  },
  {
    path: "/convert",
    name: "convert",
    component: function () {
      return import("../views/ConvertAccount.vue");
    },
  },
  {
    path: "/account",
    name: "account",
    component: function () {
      // return import("../views/AccountDetails.vue");
      return import("../views/ManageAccount.vue");
    },
  },
  {
    path: "/account/update/:blobId",
    name: "account-update",
    component: function () {
      // return import("../views/AccountDetails.vue");
      return import("../views/ManageAccountUpdate.vue");
    },
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: function () {
      return import("../views/TransactionHistory.vue");
    },
  },
  {
    path: "/transaction",
    name: "transaction",
    component: function () {
      return import("../views/CreateTransaction.vue");
    },
  },
  {
    path: "/detail",
    name: "detail",
    component: function () {
      return import("../views/TransactionDetail.vue");
    },
  },
  {
    path: "/notification",
    name: "notification",
    component: function () {
      return import("../views/Notification.vue");
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;